module.exports = __webpack_public_path__ + "img/hakuna_bg04.60df9901.jpg";